module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(_vm.message) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07c953d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SayHiFromVariable.vue
// module id = 61
// module chunks = 0